export enum AccessFrequency {
    Unlimited = 1,
    OnceAMonth = 2,
    OneOff = 3,
    OnceAWeek = 4,
}

export enum AccessReason {
    Credit = 'credit',
    Identity = 'identity',
    Comparison = 'comparison',
    PersonalFinanceManager = 'personalfinancemanager',
    DebtManagement = 'debtmanagement',
    TenantReference = 'tenantreference',
    CreditAccountManagement = 'creditaccountmanagement',
    DebtAdvice = 'debtadvice',
    DebtAdviceFJ = 'debtadvicefj',
    CreditVodafone = 'creditvodafone',
    CreditOptimum = 'creditoptimum',
    TrustDeed = 'trustdeed',
    DebtAdviceMP = 'debtadvicemp',
    ValueAlignedSpending = 'valuealignedspending',
    LoanReview = 'loanreview',
    VerifyIncomeVanquis = 'verifyincomevanquis',
    CreditNext = 'creditnext',
    Broker = 'broker',
    BrokerFF = 'brokerff',
    PersonalFinanceManagerJC = 'personalfinancemanagerjc',
    VerifyIncome = 'verifyincome',
    CreditSTB = 'creditstb',
    CreditFintern = 'creditfintern',
    StandardBroker = 'standardbroker',
    StandardVerifyIncome = 'standardverifyincome',
    Collections = 'collections',
    StandardForbearance = 'standardforbearance',
    BasicCredit = 'basiccredit',
    CreditSME = 'creditsme',
    CreditSMEID = 'creditsmeid',
    ServiceAccess = 'serviceaccess',
    CreditID = 'creditid',
    CreditLL = 'creditll',
    CreditPlus = 'creditplus',
    GrantAssessment = 'grantassessment',
    VerifyIncomeStandard = 'verifyincomestandard',
    IDInternational = 'idinternational',
    IncomeAffordability = 'incomeaffordability',
    VerifyIncomeAnalytics = 'verifyincomeanalytics',
    ResearchDevelopment = 'researchdevelopment',
    BrokerToken = 'brokertoken',
    GrantCriteria = 'grantcriteria',
    VerifyAndDispatch = 'verifyanddispatch',
    VerifyIncomePivotal = 'verifyincomepivotal',
    IncomeAffordabilityUU = 'incomeaffordabilityuu',
    TenantRefAffordability = 'tenantrefaffordability',
    TenantAffordability = 'tenantaffordability',
    VerifyBank = 'verifybank',
    BrokerTokenFF = 'brokertokenff',
    CreditRiskMasthaven = 'creditriskmasthaven',
    AffordabilityMortgageable = 'affordabilitymortgageable',
    OBID_FHI = 'obid_fhi',
    CarbonFootprint = 'carbonfootprint',
    DebtAdviceT = 'debtadvicet',
    BrokerFF2022 = 'brokerff2022',
    CreditCBS = 'creditcbs',
    CreditHandelsbanken = 'credithandelsbanken',
    TransactionVulnerabilityIndicators = 'transactionvulnerabilityindicators',
    ApplyPlus = 'applyplus',
    CreditBT = 'creditbt',
    HastingsInsurance = 'hastingsinsurance',
    BinqBroker = 'binqbroker',
    MyEquifaxIDV = 'myequifaxidv',
    MyEquifax = 'myequifax',
    MonyBroker = 'monybroker'
}

export enum AsEditorEnum {
    Text = 'text',
    Checkbox = 'checkbox',
    Select = 'select',
    Email = 'email',
    DatePicker = 'dob',
    CompanyNumber = 'companynumber',
    File = 'file',
    PDF = 'pdf',
    UkAddressLookup = 'ukaddress',
    Radio = 'radio',
}

export enum AsFieldValidationTypeEnum {
    Required = 'required',
    MaxLength = 'maxLength',
    Min = 'min',
    Max = 'max',
    Email = 'email',
    Regex = 'regex',
    UkNumber = 'ukNumber',
    UsNumber = 'usNumber',
    IndiaNumber = 'indiaNumber',
    UkPostcode = 'ukPostcode',
    Match = 'match',
    Username = 'username',

    SameAs = 'sameAs',
    MinLength = 'minLength',
}

export enum AsFieldValidationValueTypeEnum {
    Text = 'text',
    Date = 'date',
    Number = 'number',
    Regex = 'regex',
    Boolean = 'boolean',
}

export enum ValidisEnum {
    LOADING = 'LOADING',
    PROCESSING = 'PROCESSING',

    COMPLETED = 'COMPLETED',
    DOWNLOAD = 'DOWNLOAD'

}


export enum SignupProgressStateEnum {
    Start = 1,
    SelectedBank = 2,
    EnteredBankDetails = 3,
    DetailsSentToIbis = 4,
    IbisConnected = 5,
    IbisComplete = 6,
    EnterMfaDetails = 7,
    ChangeDetails = 8,
    FileUploaded = 9,
    PostedCustomerId = 10,
    FileSentToIbis = 11,
    ConsentsDetailsSubmit = 13,
    ConsentsSecuritySubmit = 14,
    ConsentsDeclined = 15,

    CustomerReferenceSubmit = 20,
    AddressSubmit = 21,


    CollectionsEmployment = 22,
    CollectionsIncome = 23,
    CollectionsHealth = 24,
    CollectionsDependants = 25,
    CollectionsArrears = 26,

    ManualIandE = 27,
    OpenBankingIandE = 28,
    RedirectScdc = 29,
    CollectionsRFD = 30,
    BackButtonClick = 40,
    IbisInvalidDetails = 50,
    IbisUserActionRequired = 51,
    IbisSystemError = 52,
    IbisBankDown = 53,
    IbisAgentError = 54,
    IbisMFAError = 55,
    IbisValidDetails = 56,
    IbisDetailsReceived = 57,
    IbisCurrentlyRefreshing = 58,
    IbisAccountLocked = 59,
    IbisFileUploadError = 60,
    IbisFileRecived = 61,
    IbisConsentsRegistered = 62,
    IbisConsentsNotRegistered = 63,
    IbisDupeSite = 64,
    OpenBankingReturn = 65,
    RequestingTransactions = 66,
    OpenBankingCancelled = 67,
    IbisMfaNeedsCompleting = 99,
    Completed = 100,
    PdfComplete = 101,
    CompletedNoTransactions = 102,
    CompletedIandE = 103,
    IbisAdditionInvalidDetails = 150,
    IbisAdditionUserActionRequired = 151,
    IbisAdditionSystemError = 152,
    IbisAdditionBankDown = 153,
    IbisAdditionAgentError = 154,
    IbisAdditionMFAError = 155,
    IbisAdditionValidDetails = 156,
    IbisAdditionDetailsReceived = 157,
    IbisAdditionAccountLocked = 159,
    CompletedAddition = 200,
    AdditionCompletedNoTransactions = 202,
    FinacialCircumstances = 203,
    Income = 204,
    HouseHoldComposition = 205,
    MonthlyExpenditure = 206,
    CreditCheckConsent = 207
}
